<h1 mat-dialog-title>User Settings</h1>
<div mat-dialog-content class="dense-1">
  <h5>Pagination Settings</h5>
  <div class="row">
    <div class="col">
      <form [formGroup]="filterForm">
        <div class="row">
          <mat-slide-toggle formControlName="pagination" (change)="sliderChange()">Pagination Enabled</mat-slide-toggle>
        </div>
        <div class="row pt-3">
          <mat-form-field>
            <mat-label>Page Size</mat-label>
            <input matInput formControlName="pageSize" type="number" (change)="requestUpdate()">
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <hr>
  <div class="row">
    <h5 class="my-auto">Optional WBS Fields</h5>
    @for (field of optionalKeys; track field) {
      <mat-checkbox [checked]="field.selected" (change)="updateOptionalSelected(field, $event.checked)">{{ field.name }}</mat-checkbox>
    }
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <h5 class="my-auto">WBS Colours</h5>
        </div>
        <div class="col-auto">
          <button class="btn-small" matMiniFab aria-label="Reset Colours" (click)="resetColours()" matTooltip="Reset to Default">
            <mat-icon>autorenew</mat-icon>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-6"></div>
        <div class="col-3 text-center">Fill</div>
        <div class="col-3 text-center">Text</div>
      </div>
      @for (colour of wbsLevelColours; track $index) {
        <div class="row">
          <div class="col-6">
            WBS Level {{ $index + 1 }}
          </div>
          <div class="col-3">
            <input matInput type="color" class="w-100" [(ngModel)]="wbsLevelColours[$index]" (change)="colourChange()">
          </div>
          <div class="col-3">
            <input matInput type="color" class="w-100" [(ngModel)]="wbsTextColours[$index]" (change)="colourChange()">
          </div>
        </div>
      }
    </div>
  </div>
  <hr>
  <div class="row">
    <button matButton="elevated" class="mat-ctrlkey-orange" (click)="clearCache()">Clear Cache</button>
  </div>
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Close</button>
</div>